import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ClientService } from '@/services/client.service';
import { LoginService } from '@/services/login.service';

export const clientRedirectGuard: CanActivateFn = (route, state) => {
  const clientService = inject(ClientService);
  const router = inject(Router);
  const loginService = inject(LoginService);
  
  const selectedClientId = clientService.selectedClientId();
  
  // If client is already selected, redirect to idp-doc-grid
  if (selectedClientId && selectedClientId !== '0') {   
    router.navigate(['home/extraction/idp-doc-grid', selectedClientId]);    
  }
  
  return true;
};
